import stylesW from '../LayoutW.module.scss'
import ListItemButton from '@mui/material/ListItemButton'
import { useLocation, useNavigate } from 'react-router-dom'

import faq from 'assets/side_pane_new_icons/faqin.svg'
import home from 'assets/side_pane_new_icons/home.svg'
import task from 'assets/side_pane_new_icons/note.svg'
import notes from 'assets/side_pane_new_icons/sticky.png'
import close from 'assets/side_pane_new_icons/close.png'
import docs from 'assets/side_pane_new_icons/document.svg'
import user_image from 'assets/side_pane_new_icons/account.png'
import reload from 'assets/side_pane_new_icons/reload.png'

import project from 'assets/side_pane_new_icons/project.svg'
import stream from 'assets/side_panel_icons/5stream.png'
import table from "assets/side_panel_icons/tabel.png";
import teams from 'assets/side_pane_new_icons/team.svg';
import userInfo from 'utils/userInfo';

const Popup = ({ x, y, closePopup }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const user = userInfo();

  let data;

  const ReRenderWindow = async () => {
    try {

    
      window.location.reload()
    } catch (error) {
      console.log("onoxo")
    }
  }

  return (
    <div className={stylesW.popup_box_shadow} style={{ top: y, left: x, }}>
      <ListItemButton
        disablePadding
        onClick={() => closePopup()}

      >
        <img className={stylesW.image_icon} src={close} alt="" />
        <p >Закрыть</p>
      </ListItemButton>
      <ListItemButton
        disablePadding
        onClick={() => ReRenderWindow()}
      >
        <img className={stylesW.image_icon} src={reload} alt="" />
        <p >Обновить</p>
      </ListItemButton>
      <hr></hr>
      
        {user?.is_personal_kyrgyzkomur ? (
        <ListItemButton
          disablePadding
          onClick={() => navigate(`/employee-card/`)}
          style={
            location.pathname.includes("employee-card")
              ? { background: '#E8E8EF' }
              : {}
          }


        >
          <img style={
            location.pathname.includes('employee-card')
              ? { filter: 'invert(0.8)' }
              : {}
          } className={stylesW.image_icon} src={home} alt="" />

          <p style={
            location.pathname.includes('employee-card')
              ? { color: 'black' }
              : {}
          }>Главная</p>
        </ListItemButton>
        ) : null}

        {!user?.is_personal_kyrgyzkomur ? (
        <ListItemButton
          disablePadding
          onClick={() => navigate(`/report-card/`)}
          style={
            location.pathname.includes("report")
              ? { background: '#E8E8EF' }
              : {}
          }


        >
          <img style={
            location.pathname.includes('report')
              ? { filter: 'invert(0.8)' }
              : {}
          } className={stylesW.image_icon} src={table} alt="" />

          <p style={
            location.pathname.includes('report')
              ? { color: 'black' }
              : {}
          }>Перевозки</p>
        </ListItemButton>
        ) : null}
 

      <hr></hr>

      <ListItemButton
        disablePadding
        onClick={() => navigate(`/personalcard`)}
        style={
          location.pathname.includes('personalcard')
            ? { background: '#E8E8EF' }
            : {}
        }

      >
        <img style={
          location.pathname.includes('home')
            ? { filter: 'invert(0.8)' }
            : {}
        } className={stylesW.image_icon} src={user_image} alt="" />
        <p >Профиль</p>
      </ListItemButton>
    



    </div>
  );
};
export default Popup